let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Ror2l")).then(() => parcelRequire('gdBO8'));